// Auto-generated by generate-photos.js — 10/4/2026
// To regenerate: node generate-photos.js

const photos = [
  {
    "id": 1,
    "title": "Brattle",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/brattle.jpg",
    "full": "/images-full/boston/brattle.jpg"
  },
  {
    "id": 2,
    "title": "Hike",
    "cat": "Burlington",
    "thumb": "/images-thumb/burlington/hike.jpg",
    "full": "/images-full/burlington/hike.jpg"
  },
  {
    "id": 3,
    "title": "Public Garden Fall",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/public-garden-fall.jpg",
    "full": "/images-full/boston/public-garden-fall.jpg"
  },
  {
    "id": 4,
    "title": "Public Garden",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/public-garden.jpg",
    "full": "/images-full/boston/public-garden.jpg"
  },
  {
    "id": 5,
    "title": "The Esplanade",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/the-esplanade.jpg",
    "full": "/images-full/boston/the-esplanade.jpg"
  },
  {
    "id": 6,
    "title": "Beetle Trap",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/beetle-trap.jpg",
    "full": "/images-full/boston/beetle-trap.jpg"
  },
  {
    "id": 7,
    "title": "Delucas Market",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/delucas-market.jpg",
    "full": "/images-full/boston/delucas-market.jpg"
  },
  {
    "id": 8,
    "title": "Me At Golden Gate",
    "cat": "San Francisco",
    "thumb": "/images-thumb/san-francisco/me-at-golden-gate.jpg",
    "full": "/images-full/san-francisco/me-at-golden-gate.jpg"
  },
  {
    "id": 9,
    "title": "Golden Gate Beach",
    "cat": "San Francisco",
    "thumb": "/images-thumb/san-francisco/golden-gate-beach.jpg",
    "full": "/images-full/san-francisco/golden-gate-beach.jpg"
  },
  {
    "id": 10,
    "title": "Baker Beach 3",
    "cat": "San Francisco",
    "thumb": "/images-thumb/san-francisco/baker-beach-3.jpg",
    "full": "/images-full/san-francisco/baker-beach-3.jpg"
  },
  {
    "id": 11,
    "title": "Baker Beach 2",
    "cat": "San Francisco",
    "thumb": "/images-thumb/san-francisco/baker-beach-2.jpg",
    "full": "/images-full/san-francisco/baker-beach-2.jpg"
  },
  {
    "id": 12,
    "title": "Baker Beach 1",
    "cat": "San Francisco",
    "thumb": "/images-thumb/san-francisco/baker-beach-1.jpg",
    "full": "/images-full/san-francisco/baker-beach-1.jpg"
  },
  {
    "id": 13,
    "title": "Tyler The Creator",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/tyler-the-creator.jpg",
    "full": "/images-full/oakland/tyler-the-creator.jpg"
  },
  {
    "id": 14,
    "title": "Stranded Records Store",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/stranded-records-store.jpg",
    "full": "/images-full/oakland/stranded-records-store.jpg"
  },
  {
    "id": 15,
    "title": "Pegasus Books",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/pegasus-books.jpg",
    "full": "/images-full/oakland/pegasus-books.jpg"
  },
  {
    "id": 16,
    "title": "Paris Texas",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/paris-texas.jpg",
    "full": "/images-full/oakland/paris-texas.jpg"
  },
  {
    "id": 17,
    "title": "Open Mind Store",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/open-mind-store.jpg",
    "full": "/images-full/oakland/open-mind-store.jpg"
  },
  {
    "id": 18,
    "title": "Northeastern Oakland",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/northeastern-oakland.jpg",
    "full": "/images-full/oakland/northeastern-oakland.jpg"
  },
  {
    "id": 19,
    "title": "My Freshman Dorm",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/my-freshman-dorm.jpg",
    "full": "/images-full/oakland/my-freshman-dorm.jpg"
  },
  {
    "id": 20,
    "title": "Me At Indian Rock",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/me-at-indian-rock.jpg",
    "full": "/images-full/oakland/me-at-indian-rock.jpg"
  },
  {
    "id": 21,
    "title": "Lunch With Cassian",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/lunch-with-cassian.jpg",
    "full": "/images-full/oakland/lunch-with-cassian.jpg"
  },
  {
    "id": 22,
    "title": "Lamp Store",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/lamp-store.jpg",
    "full": "/images-full/oakland/lamp-store.jpg"
  },
  {
    "id": 23,
    "title": "Lake Merritt",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/lake-merritt.jpg",
    "full": "/images-full/oakland/lake-merritt.jpg"
  },
  {
    "id": 24,
    "title": "Indian Rock Park 2",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/indian-rock-park-2.jpg",
    "full": "/images-full/oakland/indian-rock-park-2.jpg"
  },
  {
    "id": 25,
    "title": "Indian Rock Park 1",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/indian-rock-park-1.jpg",
    "full": "/images-full/oakland/indian-rock-park-1.jpg"
  },
  {
    "id": 26,
    "title": "Hudson Bay Cafe",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/hudson-bay-cafe.jpg",
    "full": "/images-full/oakland/hudson-bay-cafe.jpg"
  },
  {
    "id": 27,
    "title": "Friends On Telegraph",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/friends-on-telegraph.jpg",
    "full": "/images-full/oakland/friends-on-telegraph.jpg"
  },
  {
    "id": 28,
    "title": "Friends At Pacific Pipe",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/friends-at-pacific-pipe.jpg",
    "full": "/images-full/oakland/friends-at-pacific-pipe.jpg"
  },
  {
    "id": 29,
    "title": "Berkeley Thrift Market",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/berkeley-thrift-market.jpg",
    "full": "/images-full/oakland/berkeley-thrift-market.jpg"
  },
  {
    "id": 30,
    "title": "Belly Restaurant",
    "cat": "Oakland",
    "thumb": "/images-thumb/oakland/belly-restaurant.jpg",
    "full": "/images-full/oakland/belly-restaurant.jpg"
  },
  {
    "id": 31,
    "title": "West Village",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/west-village.jpg",
    "full": "/images-full/new-york/west-village.jpg"
  },
  {
    "id": 32,
    "title": "West Village Street",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/west-village-street.jpg",
    "full": "/images-full/new-york/west-village-street.jpg"
  },
  {
    "id": 33,
    "title": "Washington Square Park",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/washington-square-park.jpg",
    "full": "/images-full/new-york/washington-square-park.jpg"
  },
  {
    "id": 34,
    "title": "Planting Fields 2",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/planting-fields-2.jpg",
    "full": "/images-full/new-york/planting-fields-2.jpg"
  },
  {
    "id": 35,
    "title": "Planting Fields 1",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/planting-fields-1.jpg",
    "full": "/images-full/new-york/planting-fields-1.jpg"
  },
  {
    "id": 36,
    "title": "Me At West Village",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/me-at-west-village.jpg",
    "full": "/images-full/new-york/me-at-west-village.jpg"
  },
  {
    "id": 37,
    "title": "Highline 2",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/highline-2.jpg",
    "full": "/images-full/new-york/highline-2.jpg"
  },
  {
    "id": 38,
    "title": "Highline 1",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/highline-1.jpg",
    "full": "/images-full/new-york/highline-1.jpg"
  },
  {
    "id": 39,
    "title": "Friends At Brunch",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/friends-at-brunch.jpg",
    "full": "/images-full/new-york/friends-at-brunch.jpg"
  },
  {
    "id": 40,
    "title": "Cassian At Planting Fields",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/cassian-at-planting-fields.jpg",
    "full": "/images-full/new-york/cassian-at-planting-fields.jpg"
  },
  {
    "id": 41,
    "title": "Canal St",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/canal-st.jpg",
    "full": "/images-full/new-york/canal-st.jpg"
  },
  {
    "id": 42,
    "title": "Beanmonger Coffee",
    "cat": "New York",
    "thumb": "/images-thumb/new-york/beanmonger-coffee.jpg",
    "full": "/images-full/new-york/beanmonger-coffee.jpg"
  },
  {
    "id": 43,
    "title": "Sunset At Old Montreal",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/sunset-at-old-montreal.jpg",
    "full": "/images-full/montreal/sunset-at-old-montreal.jpg"
  },
  {
    "id": 44,
    "title": "Old Montreal 2",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/old-montreal-2.jpg",
    "full": "/images-full/montreal/old-montreal-2.jpg"
  },
  {
    "id": 45,
    "title": "Old Montreal 1",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/old-montreal-1.jpg",
    "full": "/images-full/montreal/old-montreal-1.jpg"
  },
  {
    "id": 46,
    "title": "Me At Conservatory",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/me-at-conservatory.jpg",
    "full": "/images-full/montreal/me-at-conservatory.jpg"
  },
  {
    "id": 47,
    "title": "Library",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/library.jpg",
    "full": "/images-full/montreal/library.jpg"
  },
  {
    "id": 48,
    "title": "Le Cafe Big Trouble",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/le-cafe-big-trouble.jpg",
    "full": "/images-full/montreal/le-cafe-big-trouble.jpg"
  },
  {
    "id": 49,
    "title": "Conservatory",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/conservatory.jpg",
    "full": "/images-full/montreal/conservatory.jpg"
  },
  {
    "id": 50,
    "title": "Conservatory 2",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/conservatory-2.jpg",
    "full": "/images-full/montreal/conservatory-2.jpg"
  },
  {
    "id": 51,
    "title": "Church",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/church.jpg",
    "full": "/images-full/montreal/church.jpg"
  },
  {
    "id": 52,
    "title": "Cassian On Stairs",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/cassian-on-stairs.jpg",
    "full": "/images-full/montreal/cassian-on-stairs.jpg"
  },
  {
    "id": 53,
    "title": "Cassian At Conservatory",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/cassian-at-conservatory.jpg",
    "full": "/images-full/montreal/cassian-at-conservatory.jpg"
  },
  {
    "id": 54,
    "title": "Cassian And I",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/cassian-and-i.jpg",
    "full": "/images-full/montreal/cassian-and-i.jpg"
  },
  {
    "id": 55,
    "title": "Cafe",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/cafe.jpg",
    "full": "/images-full/montreal/cafe.jpg"
  },
  {
    "id": 56,
    "title": "Cafe 2",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/cafe-2.jpg",
    "full": "/images-full/montreal/cafe-2.jpg"
  },
  {
    "id": 57,
    "title": "Basilica",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/basilica.jpg",
    "full": "/images-full/montreal/basilica.jpg"
  },
  {
    "id": 58,
    "title": "After Dinner",
    "cat": "Montreal",
    "thumb": "/images-thumb/montreal/after-dinner.jpg",
    "full": "/images-full/montreal/after-dinner.jpg"
  },
  {
    "id": 59,
    "title": "Perkins Park 2",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/perkins-park-2.jpg",
    "full": "/images-full/monterey/perkins-park-2.jpg"
  },
  {
    "id": 60,
    "title": "Perkins Park 1",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/perkins-park-1.jpg",
    "full": "/images-full/monterey/perkins-park-1.jpg"
  },
  {
    "id": 61,
    "title": "Monterey Boardwalk",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/monterey-boardwalk.jpg",
    "full": "/images-full/monterey/monterey-boardwalk.jpg"
  },
  {
    "id": 62,
    "title": "Me At Perkins Park",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/me-at-perkins-park.jpg",
    "full": "/images-full/monterey/me-at-perkins-park.jpg"
  },
  {
    "id": 63,
    "title": "Looking Point 2",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/looking-point-2.jpg",
    "full": "/images-full/monterey/looking-point-2.jpg"
  },
  {
    "id": 64,
    "title": "Looking Point 1",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/looking-point-1.jpg",
    "full": "/images-full/monterey/looking-point-1.jpg"
  },
  {
    "id": 65,
    "title": "Friend Whale Watching",
    "cat": "Monterey",
    "thumb": "/images-thumb/monterey/friend-whale-watching.jpg",
    "full": "/images-full/monterey/friend-whale-watching.jpg"
  },
  {
    "id": 66,
    "title": "Ship",
    "cat": "Lake Tahoe",
    "thumb": "/images-thumb/lake-tahoe/ship.jpg",
    "full": "/images-full/lake-tahoe/ship.jpg"
  },
  {
    "id": 67,
    "title": "Dock",
    "cat": "Lake Tahoe",
    "thumb": "/images-thumb/lake-tahoe/dock.jpg",
    "full": "/images-full/lake-tahoe/dock.jpg"
  },
  {
    "id": 68,
    "title": "Coffee truck",
    "cat": "Lake Tahoe",
    "thumb": "/images-thumb/lake-tahoe/coffee truck.jpg",
    "full": "/images-full/lake-tahoe/coffee truck.jpg"
  },
  {
    "id": 69,
    "title": "Vinyl Spinning",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/vinyl-spinning.jpg",
    "full": "/images-full/boston/vinyl-spinning.jpg"
  },
  {
    "id": 70,
    "title": "Versus",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/versus.jpg",
    "full": "/images-full/boston/versus.jpg"
  },
  {
    "id": 71,
    "title": "Sowa Open Market",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/sowa-open-market.jpg",
    "full": "/images-full/boston/sowa-open-market.jpg"
  },
  {
    "id": 72,
    "title": "South End Art",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/south-end-art.jpg",
    "full": "/images-full/boston/south-end-art.jpg"
  },
  {
    "id": 73,
    "title": "Party On The Common",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/party-on-the-common.jpg",
    "full": "/images-full/boston/party-on-the-common.jpg"
  },
  {
    "id": 74,
    "title": "Party On The Common 2",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/party-on-the-common-2.jpg",
    "full": "/images-full/boston/party-on-the-common-2.jpg"
  },
  {
    "id": 75,
    "title": "Me At Cambridgeside",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/me-at-cambridgeside.jpg",
    "full": "/images-full/boston/me-at-cambridgeside.jpg"
  },
  {
    "id": 76,
    "title": "Matchas",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/matchas.jpg",
    "full": "/images-full/boston/matchas.jpg"
  },
  {
    "id": 77,
    "title": "Isabella Gardner",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/isabella-gardner.jpg",
    "full": "/images-full/boston/isabella-gardner.jpg"
  },
  {
    "id": 78,
    "title": "Isabella Gardner 3",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/isabella-gardner-3.jpg",
    "full": "/images-full/boston/isabella-gardner-3.jpg"
  },
  {
    "id": 79,
    "title": "Isabella Gardner 2",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/isabella-gardner-2.jpg",
    "full": "/images-full/boston/isabella-gardner-2.jpg"
  },
  {
    "id": 80,
    "title": "Isabella Gardner 1",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/isabella-gardner-1.jpg",
    "full": "/images-full/boston/isabella-gardner-1.jpg"
  },
  {
    "id": 81,
    "title": "Friends At Boston Common",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/friends-at-boston-common.jpg",
    "full": "/images-full/boston/friends-at-boston-common.jpg"
  },
  {
    "id": 82,
    "title": "Friends At Boston Common 2",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/friends-at-boston-common-2.jpg",
    "full": "/images-full/boston/friends-at-boston-common-2.jpg"
  },
  {
    "id": 83,
    "title": "Duo Birthday",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/duo-birthday.jpg",
    "full": "/images-full/boston/duo-birthday.jpg"
  },
  {
    "id": 84,
    "title": "Duck",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/duck.jpg",
    "full": "/images-full/boston/duck.jpg"
  },
  {
    "id": 85,
    "title": "Cassian At Cambridgeside",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/cassian-at-cambridgeside.jpg",
    "full": "/images-full/boston/cassian-at-cambridgeside.jpg"
  },
  {
    "id": 86,
    "title": "Cassian And I At Sowa",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/cassian-and-i-at-sowa.jpg",
    "full": "/images-full/boston/cassian-and-i-at-sowa.jpg"
  },
  {
    "id": 87,
    "title": "Cassian And I At Lous",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/cassian-and-i-at-lous.jpg",
    "full": "/images-full/boston/cassian-and-i-at-lous.jpg"
  },
  {
    "id": 88,
    "title": "Cassian And I At Isabella Gardner Museum",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/cassian-and-i-at-isabella-gardner-museum.jpg",
    "full": "/images-full/boston/cassian-and-i-at-isabella-gardner-museum.jpg"
  },
  {
    "id": 89,
    "title": "Boston Common Autumn",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/boston-common-autumn.jpg",
    "full": "/images-full/boston/boston-common-autumn.jpg"
  },
  {
    "id": 90,
    "title": "Beacon Hill Sunset",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/beacon-hill-sunset.jpg",
    "full": "/images-full/boston/beacon-hill-sunset.jpg"
  },
  {
    "id": 91,
    "title": "Beacon Hill Autumn",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/beacon-hill-autumn.jpg",
    "full": "/images-full/boston/beacon-hill-autumn.jpg"
  },
  {
    "id": 92,
    "title": "Back Bay Fens",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/back-bay-fens.jpg",
    "full": "/images-full/boston/back-bay-fens.jpg"
  },
  {
    "id": 93,
    "title": "Back Bay Fens Autumn",
    "cat": "Boston",
    "thumb": "/images-thumb/boston/back-bay-fens-autumn.jpg",
    "full": "/images-full/boston/back-bay-fens-autumn.jpg"
  }
];

export default photos;
